import React, { useState } from "react";
import { OverflowSet } from '@fluentui/react/lib/OverflowSet';
import List from '../../../Templates/List';
import DisabledCard from '../../../Templates/CCard/DisabledCard';
import { useTranslation } from "react-i18next";
import { Card, Row, Col } from "react-bootstrap"
import { useGetEventHomeLast } from '../../../../hooks/services/sBook/useOfMessajeEvent'
import NoDataLayer from "../../../Common/NoDataLayer";
import moment from "moment-timezone"
import SidePanelViewCommentEvent from "./SidePanelViewCommentEvent";
import { useHistory } from "react-router-dom";
import ToolBar from "../../../Common/Toolbar";
import ListPagination from "../../../Templates/List/ListPagination";
import { __onRenderOverflowButton, __onRenderOverflowItem } from "../../../../common/CommonFuctions";
import { ScrollablePane, ScrollbarVisibility, SpinnerSize } from "@fluentui/react";
import { convertToLocalClientTimeZone } from "../../../../common/Helpers";
import Loading from "../../../Templates/Site/Loading";

function MessageLastEventsBox(props) {
    const { t } = useTranslation();
    const history = useHistory();


    //Parametros de entrada.

    //Parametros de componente.
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const [selectedMessageEvent, setSelectedMessageEvent] = useState(false);
    const [numberOfItems, setNumberOfItems] = useState(10);

    const [messageEventList, setMessageEventList] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 10, filters: []});
    const [messageDataLength, setMessageDataLength] = useState(0);
    const [dataFilled, setDataFilled] = useState(false);
    useGetEventHomeLast(messageEventList, setMessageEventList, numberOfItems, setNumberOfItems, dataFilled, setDataFilled);

   
    const onGetMoreData = () => {
        if (messageEventList.data.length !== messageDataLength) {
            setMessageEventList(prevState => ({
                ...prevState,
                data: null,
                fireUpdate: true, 
                totalRecords: messageEventList.data.length + 10,
                totalPages:  (messageEventList.data.length + 10) / messageEventList.pageSize
            }));
            setMessageDataLength(messageEventList.data.length)
        }
    }

    const onViewBook = (bookId, messageId) => {
        history.push({
            pathname: `/Book/Book/${ bookId }/${ messageId }`
        })
    }

    const onSelectMessageClick = (messageEvent) => {
        setSelectedMessageEvent(messageEvent)
        setIsPanelOpen(true);
    }


  

    const displayMessageEventsBox = true;

    const toolBarItems_Communication  = [
        {
            key: 'showmore',
            text: t('data-lang-btn-showmore'),
            iconProps: { iconName: 'CPlusPlusLanguage' },
            onClick: onGetMoreData,
        },
    ];

    const displayToolBarCommunication = true;

    return (
        <Card className='book-party-roles-form'>
            <DisabledCard display={ !displayMessageEventsBox } />
            <Row className='child2'>
                <Col>
                    <Card.Header className="card-header-compact">
                        <Card.Title className="d-flex justify-content-between">
                            <b>{t('data-lang-boxname-lastmessageeventsshort')}</b>
                            <div className='book-toolbar'>
                                <ToolBar items={ toolBarItems_Communication } styles={{root:{height: "30px"}}} display={ displayToolBarCommunication } />
                            </div>
                        </Card.Title>
                    </Card.Header>
                    <Card.Body className="book-party-roles-form-body overflow-auto">
                        <ScrollablePane
                            style={{minHeight: "835px", maxHeight: "100%", height: "100%"}}
                            styles={{
                                root: { position: "relative" },
                                contentContainer:{overflowX: "hidden"}
                            }}
                            scrollbarVisibility={ScrollbarVisibility.auto}
                            scrollContainerFocus={true}
                        >
                            {
                                displayMessageEventsBox &&
                                <>
                                    {
                                        !(messageEventList && messageEventList.data) &&
                                        <Row className="h-100">
                                            <Col className="d-flex align-items-center justify-content-center">
                                                <Loading
                                                    inputParam_ShowLoading={true}
                                                    inputParam_ShowText={false}
                                                    inputParam_Width={'35px'}
                                                    inputParam_Height={'35px'}
                                                    inputParam_Left={""}
                                                    inputParam_Style={{marginTop: 0}}
                                                    inputParam_ColClassName={"me-2"}
                                                    inputParam_MarginLeft={"auto"}
                                                    inputParam_SpinnerSize={SpinnerSize.medium} />
                                            </Col>
                                        </Row>
                                    }
                                    {
                                        (messageEventList && messageEventList.data) &&
                                        <Row>
                                            <List
                                                manipulateLocalData={ true }
                                                className="no-compact-list big-header"
                                                listLocalStoragePageSizeVariableName="lastEventMessages"
                                                data={ (messageEventList !== null ? messageEventList : []) }
                                                setData={ setMessageEventList }
                                                columns={ (messageEventList && messageEventList.data) ? [
                                                {
                                                    key: 'all-props-all-props',
                                                    name: t('data-lang-lbl-type'),
                                                    fieldName: 'all-props-all-props',
                                                    onRender:(item) => {
                                        
                                                        const html = <Row data-id={item.id} style={{cursor: "pointer"}} onClick={() => onViewBook(item.bookId, item.messageId)}>
                                                            
                                                                        <Col xl={12}>
                                                                            <Row>
                                                                                <Col>
                                                                                    <b>{`${t('data-lang-lbl-book')}: ${item.bookCode}`}</b>
                                                                                </Col>
                                                                                <Col className="col-auto me-auto">{ convertToLocalClientTimeZone(item.messageEventDate) }</Col>
                                                                            </Row>
                                                                        </Col>
                                                                        <Col xl={12}>{`${item.messageCode} | ${item.messageTitle}`}</Col>
                                                                        <Col xl={12} title={item.messageUsername}>{`${t(item.messageEventName)} | ${item.messageEventFullname}`}</Col>
                                                                        {
                                                                            item.contratName && <Col xl={12}>{ item.contratName }</Col>
                                                                        }
                                                                        {
                                                                            item.projectName && <Col xl={12}>{ item.projectName }</Col>
                                                                        }
                                                                    </Row>
                                        
                                                        return  html;
                                                    }
                                                },
                                                {  
                                                    key: 'id',
                                                    name: t('data-lang-lbl-actions'),
                                                    fieldName: 'id',
                                                    minWidth: 90,
                                                    maxWidth: 90,
                                                    onRender:(item, row) => {
                                        
                                        
                                                        const items = item.messageEventName.toLowerCase() === "data-lang-sbmessageevent-type-comment" || item.messageEventName.toLowerCase() === "data-lang-sbmessageevent-type-comment-visa" ? [
                                                            {
                                                                key: 'item1',
                                                                icon: 'View',
                                                                name: t('data-lang-btn-viewcomment'),
                                                                title: t('data-lang-btn-viewcomment'),
                                                                onClick: () => onSelectMessageClick(item),
                                                            }
                                                        ] : [];
                                                        
                                        
                                        
                                                        return <div>
                                                                <OverflowSet
                                                                    className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                                                                    role="menubar"
                                                                    items={ items }
                                                                    onRenderOverflowButton={__onRenderOverflowButton}
                                                                    onRenderItem={__onRenderOverflowItem}
                                                                />
                                                        </div>
                                                    }
                                                }
                                            ] : [] } />
                                        </Row>
                                    }
                                </>
                            }
                            <NoDataLayer display={ !displayMessageEventsBox } />
                        </ScrollablePane>
                    </Card.Body>
                    <Card.Footer>
                        {
                            displayMessageEventsBox &&
                            <>
                                <ListPagination
                                    listLocalStoragePageSizeVariableName="lastEventMessages"
                                    data={ (messageEventList !== null ? messageEventList : []) }
                                    setData={ setMessageEventList } />
                            </>
                        }
                    </Card.Footer>
                </Col>
            </Row>
            <SidePanelViewCommentEvent
                messageEventObject={ selectedMessageEvent }
                isPanelOpen={ isPanelOpen }
                setterIsPanelOpen={ setIsPanelOpen }
            />  
        </Card>
    );
}

export default MessageLastEventsBox;

